import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const InLineControlRulesTableColumns: ITableColumn[] = [
  {
    labelPath: 'policyPage.policy.inLineControlRules.tableColumns.ruleName',
    propertyKey: 'ruleName',
    colType: TableColumnTypeEnum.InternalNavigation,
    width: 38,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'ruleName',
    internalNavigationQuery: 'inLineControlRulesEndpointQuery',
    internalNavigationRoute: 'inLineControlRulesEndpointRoute',
  },
  {
    labelPath: 'policyPage.policy.inLineControlRules.tableColumns.ruleId',
    propertyKey: 'ruleId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 10,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'ruleId',
  },
  {
    labelPath: 'policyPage.policy.inLineControlRules.tableColumns.severity',
    propertyKey: 'severity',
    colType: TableColumnTypeEnum.SeverityLabel,
    width: 13,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'severity',
  },
  {
    labelPath: 'policyPage.policy.inLineControlRules.tableColumns.detection',
    propertyKey: 'detection',
    colType: TableColumnTypeEnum.Toggle,
    width: 13,
    widthType: WidthType.Percentage,
    toCapitalize: true,
  },
  {
    labelPath: 'policyPage.policy.inLineControlRules.tableColumns.prevention',
    propertyKey: 'prevention',
    iconTableClass: 'table-icon',
    colType: TableColumnTypeEnum.Toggle,
    width: 13,
    widthType: WidthType.Percentage,
  },
  {
    labelPath: 'policyPage.policy.inLineControlRules.tableColumns.status',
    propertyKey: 'status',
    colType: TableColumnTypeEnum.StatusLabel,
    isSortable: true,
    sortKey: 'status',
    width: 13,
    widthType: WidthType.Percentage,
    toCapitalize: true,
  },
];
